module.exports = __webpack_public_path__ + "media/images/new-ui-images/pre-arrow-98ddbc0d5427ddb26bfd121bcf85d5db.svg";